module.exports = function (app, mod) {
  var html = "\n\t\t\t<div id=\"modtools-settings\" class=\"saito-module-settings\">\n\t";
  var server_c = '';
  var friends_c = '';
  var custom_c = '';
  var none_c = '';
  if (mod.permissions.mode == 'none') {
    none_c = 'checked';
  }
  if (mod.permissions.mode == 'server' || mod.permissions.mode == 'public') {
    server_c = 'checked';
  }
  if (mod.permissions.mode == 'friends') {
    friends_c = 'checked';
  }
  if (mod.permissions.mode == 'custom') {
    custom_c = 'checked';
  }
  html += "\n\n            <fieldset class=\"saito-grid\">\n            \t<legend class=\"settings-label\">Who Moderates:</legend>\n\n            \t<input class=\"saito-radio\" type=\"radio\" id=\"none_mod\" name=\"who_moderates\" value=\"none_mod\" ".concat(none_c, ">\n            \t<label for=\"none_mod\">Me <span class=\"note\">- I handle my own moderation</span></label>\n\n            \t<input class=\"saito-radio\" type=\"radio\" id=\"custom_mod\" name=\"who_moderates\" value=\"custom_mod\" ").concat(custom_c, ">\n            \t<label for=\"custom_mod\">Custom <span class=\"note\">- selected accounts from my friends and contacts</span></label>\n\n            \t<input class=\"saito-radio\" type=\"radio\" id=\"friends_mod\" name=\"who_moderates\" value=\"friends_mod\" ").concat(friends_c, ">\n            \t<label for=\"friends_mod\">Friends <span class=\"note\">- my friends and contacts</span></label>\n\n            \t<input class=\"saito-radio\" type=\"radio\" id=\"server_mod\" name=\"who_moderates\" value=\"server_mod\" ").concat(server_c, ">\n            \t<label for=\"server_mod\">Server <span class=\"note\">- accept moderation lists from the server I am connected to</span></label>\n\n            </fieldset>\n\n\t");

  //        if (app.options.modtools.whitelist.length > 0){
  html += "<fieldset id=\"whitelisted-accounts\" class=\"saito-grid settings-link\">\n                <i class=\"fa-regular fa-face-smile-beam\"></i>\n                <label>Manage Whitelisted Accounts (".concat(app.options.modtools.whitelist.length, ")</label>\n                <div id=\"add-whitelist\" class=\"saito-grid-extra-button saito-button-secondary\">Add</div>\n                </fieldset>");
  //        }

  //        if (app.options.modtools.blacklist.length > 0){
  html += "<fieldset id=\"blacklisted-accounts\" class=\"saito-grid settings-link\">\n                <i class=\"fa-solid fa-ban\"></i>\n                <label>Manage Blocked Accounts (".concat(app.options.modtools.blacklist.length, ")</label>\n                </fieldset>");

  /*html += `
                <fieldset id="modtools-apps" class="saito-grid">
             	<legend class="settings-label">App Permissions:</legend>
             	<div class="modtools-app-permissions" id="modtools-app-permissions">
  			</div>
  				<div class="add-new-permission-box" id="add-new-permission-box"></div>
  			<div class="saito-button-primary small" id="modtools-apps-add-new">+</div>
                </fieldset>`;
                */
  //        }

  html += "\n\t\t\t</div>\n\t";
  return html;
};